"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(value) {
  var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "XXX XX XXX";
  var stringValue = "" + value;
  var returnValue = "";
  var indexString = 0;

  for (var indexMask = 0; indexMask < mask.length && indexString < stringValue.length; indexMask++) {
    returnValue += mask.charAt(indexMask) === "X" ? stringValue.charAt(indexString++) : mask.charAt(indexMask);
  }

  return returnValue;
};

exports["default"] = _default;